import { getCurrentUser, updateUser } from "../scripts/api";
import { bindKey } from "../scripts/binding";

// DOM elements
const moveStreakDiv = document.getElementById("move-streak")!;
const accuracyDiv = document.getElementById("accuracy")!;

// State
let moveStreak = 0;
let bestMoveStreak = 0;

export async function loadMoveStreak() {
  const user = await getCurrentUser();
  const details = user?.user_metadata.visionMoveStreak || {};
  moveStreak = details.current || 0;
  bestMoveStreak = details.best || 0;
  renderMoveStreak();
}

export function incrementMoveStreak() {
  moveStreak++;
  if (moveStreak > bestMoveStreak) bestMoveStreak = moveStreak;
  renderMoveStreak();
}

export function resetMoveStreak() {
  moveStreak = 0;
  updateUser({
    visionMoveStreak: { best: bestMoveStreak, current: moveStreak },
  });
  renderMoveStreak();
}

export async function saveMoveStreak() {
  return updateUser({
    visionMoveStreak: { best: bestMoveStreak, current: moveStreak },
  });
}

function renderMoveStreak() {
  // Show move streak if it's close to the best move streak or if the best move
  // streak is low. Otherwise, show accuracy
  if (bestMoveStreak < 30 || moveStreak >= 0.75 * bestMoveStreak) {
    moveStreakDiv.hidden = false;
    accuracyDiv.hidden = true;
  } else {
    moveStreakDiv.hidden = true;
    accuracyDiv.hidden = false;
  }
  bindKey("move-streak", moveStreak.toLocaleString());
  bindKey("best-move-streak", bestMoveStreak.toLocaleString());
  // Animate the move streak if it's increasing
  if (moveStreak > 0) {
    moveStreakDiv.classList.add("animate-increment");
    setTimeout(() => {
      moveStreakDiv.classList.remove("animate-increment");
    }, 600);
  }
}
